// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueResource from 'vue-resource'
import AuthPlugin from './plugins/auth'
import EnvironmentPlugin from './plugins/environment'
import ToolPlugin from './plugins/tool'
import LoggerPlugin from './plugins/logger'
import JpegCameraPlugin from './plugins/jpegCamera'
import ParamPlugin from './plugins/param'
import TimePlugin from './plugins/time'
import GoogleMapPlugin from './plugins/googlemap'
import TagManagerPlugin from './plugins/tagManager'

Vue.use(VueResource)

Vue.use(ToolPlugin)
Vue.use(EnvironmentPlugin)
Vue.use(TimePlugin)
Vue.use(LoggerPlugin)
Vue.use(AuthPlugin)
Vue.use(JpegCameraPlugin)
Vue.use(ParamPlugin)
Vue.use(GoogleMapPlugin)
Vue.use(TagManagerPlugin)

Vue.config.productionTip = false

if (Vue.env.isChektDomain && Vue.env.isProduction) {
  Vue.logger.setLogLevel('WARNING') // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
  Vue.tagManager.appendTags()
} else {
  Vue.logger.setLogLevel('DEBUG') // 'DEBUG', 'INFO', 'WARNING', 'ERROR'
}
Vue.logger.getLogLevelFromLocalStorage()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js